import { IPublicWifiProduct } from "../store/reducers/public-wifi-pxsplus.reducer";
import { getPiiServiceId } from "src/app/shared/pii/pii.utils";

const SESSION_DEVICE_TYPE = 'mprdDeviceType';
const IOS_REGEXP = /iphone|ipod|ipad/;

export function deduceDeviceType(): 'android' | 'ios' {
  let os = window.sessionStorage
    ?.getItem(SESSION_DEVICE_TYPE)
    ?.toLowerCase() as 'android' | 'ios' | undefined;
  if (!os) {
    // In some cases, the session storage is not correctly set up.
    // We can detect if we're on iOS using the user-agent header. However, detecting Android can't
    // be reliably done on the client. Reference: https://stackoverflow.com/a/37705154
    const agent = window.navigator?.userAgent?.toLowerCase();
    os = IOS_REGEXP.test(agent) ? 'ios' : 'android';
  }
  return os;
}

export function getPublicWiFiPxsplusProductServiceId(products: Array<IPublicWifiProduct>): string {
  let serviceId;
  if (products && products.length === 1) {
    serviceId = products[0].serviceId;
  } else {
    serviceId = getPiiServiceId();
  }

  return serviceId;
}
